import TanstackTable from './TanstackTable';

export { useTanstackTable } from './useTanstackTable';
export { defineColumns } from './columns';
export {
  TanstackTableLocaleProvider,
  useTanstackTableLocale,
  defaultTanstackTableLocale,
} from './locale';
export type { TanstackTableLocale } from './locale';
export { TANSTACK_TABLE_PART, partSelector, findPart, findParts } from './parts';
export type { TanstackTablePart } from './parts';
export {
  equalsValueFilter,
  multiSelectFilter,
  booleanFilter,
  dateRangeFilter,
  defaultFilterFnFor,
} from './filterFns';

export type {
  TanstackTableProps,
  TanstackTableClientProps,
  TanstackTableServerProps,
  TanstackTableMode,
  PageSizeOption,
  TanstackTableAlign,
  TanstackTableDensity,
  TanstackTableClassNames,
  TanstackTableFilterVariant,
  TanstackTableFilterOption,
  TanstackTableColumnFacet,
  TanstackTableControlledState,
  TanstackTableStateValues,
  TanstackTableFeatureFlags,
  TanstackTableStateCallbacks,
  ColumnDef,
  ColumnFiltersState,
  ColumnOrderState,
  ColumnPinningState,
  ColumnSizingState,
  ExpandedState,
  GroupingState,
  PaginationState,
  Row,
  RowSelectionState,
  SortingState,
  TableState,
  VisibilityState,
} from './types';

export {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  type CellContext,
  type HeaderContext,
  type Table as TanstackTableInstance,
  type Header,
  type Cell,
  type Column,
  type ColumnHelper,
} from '@tanstack/react-table';

export default TanstackTable;
